import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBGZFGoZe01Qb_ASNpMawfVGDkW3bj8uio",
  authDomain: "clubmasiva-a8fc4.firebaseapp.com",
  projectId: "clubmasiva-a8fc4",
  storageBucket: "clubmasiva-a8fc4.appspot.com",
  messagingSenderId: "646022444062",
  appId: "1:646022444062:web:3ea0710997ccbe63406a0f"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { app, db, storage, auth };